module.exports = __webpack_public_path__ + "img/leftBg.c730f956.png";